import i18n from "../../locales/i18n";
import * as api from "../../service/ApiSevice";
export const actions = {
  DoGetUnseenNotificationCount({ state, commit }, merchantId) {
    api.NotificationService.DoGetUnseenNotificationCount(merchantId).then(async (res) => {
      if (res.status.IsSuccess()) {
        await commit("MutationGetNotificationCount", {
          merchantId: merchantId,
          notificationCount: res.data.notificationCount,
        });
      }
    });
  },
  DoGetAllNotificationList({ state, commit }, merchantId) {
    const doGetUnseenNotificationList = api.NotificationService.DoGetUnseenNotificationList(merchantId).then((res) => {
      if (res.status.IsSuccess()) {
        const unreadNotificationList = [...res.data.list];
        return unreadNotificationList;
      }
    });

    const doGetSeenNotificationList = api.NotificationService.DoGetSeenNotificationList(merchantId).then((res) => {
      if (res.status.IsSuccess()) {
        const readNotificationList = [...res.data.list];
        return readNotificationList;
      }
    });

    Promise.all([doGetUnseenNotificationList, doGetSeenNotificationList]).then(async (results) => {
      const input = {
        merchantId: merchantId,
        unreadNotificationList: results[0],
        readNotificationList: results[1],
      };

      await commit("MutationGetAllNotificationList", input);
    });
  },
  DoDeleteUnseenNotification({ state, commit }, input) {
    api.NotificationService.DoDeleteUnseenNotification(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Something_Wrong"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
  DoDeleteSeenNotification({ state, commit }, input) {
    api.NotificationService.DoDeleteSeenNotification(input.merchantId, input.notificationId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Something_Wrong"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
  DoSetAllNotificationIsSeen({ state, commit }, merchantId) {
    api.NotificationService.DoSetAllNotificationIsSeen(merchantId).then(async (res) => {
      if (!res.status.IsSuccess()) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Something_Wrong"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
};
